import ReactRenderer from '../../resources/js/modules/_react-renderer'
import { GraphSliderTextItems } from './js/graph-slider-text-items'

ReactRenderer.registerComponent('GraphSliderTextItems', GraphSliderTextItems)
